import {useEffect} from 'react';

/**
 * Silently auto-selects hidden slots on mount / when steps change.
 * Slots with isVisible=false are not shown to the user but must have a selection
 * so they can be included in the cart payload. The first available product is injected
 * into selections without user interaction.
 *
 * @param {Array}    steps     - Array of step definitions from buildSteps()
 * @param {Object}   selections - Current selections map
 * @param {Function} onSelect  - Selection update callback(containerId, slotSelections)
 */
export function useAutoSelectHiddenSlots(steps, selections, onSelect) {
  useEffect(() => {
    steps.forEach((step) => {
      if (!step.container) return;

      step.container.values.forEach((slot, slotIndex) => {
        if (slot.isVisible !== false) return;
        if (!slot.products || slot.products.length === 0) return;

        const existing = selections?.[step.id]?.[slotIndex];

        if (existing) return;

        const autoProduct = slot.products[0];

        if (!autoProduct?.productId) return;

        const updatedSlotSelections = [...(selections?.[step.id] || [])];

        updatedSlotSelections[slotIndex] = {
          productId: autoProduct.productId,
          isAutoSelected: true,
          isHidden: true,
          recommendationName: slot.typeName || step.container?.containerName || null,
          recommendationTypeId: slot.recommendationTypeId,
          slotIndex,
        };

        onSelect(step.container.containerId, updatedSlotSelections);
      });
    });
    // Run only when steps identity changes (product loaded/changed)
  }, [steps]);
}
